import { getStorage } from './index';

/**
 * @deprecated Replaced by axios interceptor
 */
export const setToken = () => {
    return undefined;
};

/**
 * Get the token of the logged-in user (for use in non-axios requests)
 * @returns {string}
 */
export const getToken = () => {
    const token = getStorage('token');
    if (token) {
        return token;
    }

    throw Error('No logged in user found.');
};

/**
 * Check if the user is allowed to access a location
 * @param user {IUser}
 * @param locationId {number}
 * @returns {boolean}
 */
export const isUserHasLocation = (user, locationId) => {
    if (!user || !locationId) return false;
    // WFM/WTM see all locations; aligned with seesAllLocations in
    // useLocationsByLoggedInUserRole. TEF aliases to WFM at the HEMT-fetch
    // boundary so it's covered by isWFMUser here.
    if (user.isWFMUser || user.isWTMUser) return true;

    const userLocations = [].concat(user.primaryLocationId, user.additionalLocationIds);
    return userLocations.map(Number).includes(Number(locationId));
};
